export default __webpack_public_path__ + "static/media/TempEvent.fc8bef8d.jpg";